<template>
	<div class="grid">
		<div class="col-12 lg:col-6 xl:col-3">
			<div class="card mb-0">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Ventas, últimos 7 días</span>
						<div class="text-900 font-medium text-xl">{{ this.last7daysSalesAmount }}</div>
					</div>
					<div class="flex align-items-center justify-content-center border-round" style="width:2.5rem;height:2.5rem; background: #f18700;">
						<img src="layout/images/iconos-landingpage/1-19.png" class="bottom-0" alt="icon-1" style="width: 3rem;">
					</div>
				</div>
				<span :class="{'text-green-500': (this.last30daysSalesAmount>1), 'font-medium': true}">{{ this.last30daysSalesAmount }} {{" " + ((this.last30daysSalesAmount == 1) ? " venta" : "ventas" ) }}</span>
				<span class="text-500">en los últimos 30 días</span>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div class="card mb-0">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Ingresos, últimos 7 días</span>
						<div class="text-900 font-medium text-xl">${{ this.last7daysSalesTotal.toFixed(2) }}</div>
					</div>
					<div class="flex align-items-center justify-content-center border-round" style="width:2.5rem;height:2.5rem; background: #6ebb71;">
						<img src="layout/images/iconos-landingpage/1-20.png" class="bottom-0" alt="icon-1" style="width: 3rem;">
					</div>
				</div>
				<span :class="{'text-green-500': (this.last30daysSalesTotal>0), 'font-medium': true}">${{ this.last30daysSalesTotal.toFixed(2) }}</span>
				<span class="text-500">en los últimos 30 días</span>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div class="card mb-0">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Gastos, últimos 7 días</span>
						<div class="text-900 font-medium text-xl">${{ this.last7DaysExpensesTotal.toFixed(2) }}</div>
					</div>
					<div class="flex align-items-center justify-content-center border-round" style="width:2.5rem;height:2.5rem; background: #dd4444;">
						<img src="layout/images/iconos-landingpage/1-21.png" class="bottom-0" alt="icon-1" style="width: 3rem;">
					</div>
				</div>
				<span :class="{'text-blue-500': (this.last30DaysExpensesTotal>0), 'font-medium':true}">${{ this.last30DaysExpensesTotal.toFixed(2) }}</span>
				<span class="text-500">en los últimos 30 días</span>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div class="card mb-0">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Clientes</span>
						<div class="text-900 font-medium text-xl">{{ this.customerAmount }}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-purple-100 border-round" style="width:2.5rem;height:2.5rem">
						<img src="layout/images/iconos-landingpage/1-22.png" class="bottom-0" alt="icon-1" style="width: 3rem;">
					</div>
				</div>
				<span :class="{'text-blue-500': (this.last7DaysCustomers > 0), 'font-medium':true}"> {{ this.last7DaysCustomers }} {{" " + ((this.last7DaysCustomers == 1) ? " cliente" : "clientes" ) }}</span>
				<span class="text-500">En los últimos 7 días</span>
			</div>
		</div>

	<div class="col-12 xl:col-6">
		<div class="card">
			<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
				<h5 class="m-0">Resumen de Movimientos</h5>
				<Dropdown class="w-full md:w-auto" v-model="finantialReportTimeSelected" :options="finatialReportTimeOptions" optionLabel="name" @change="onFinantialReportTimeChanged()"></Dropdown>
			</div>
			<Chart type="line" :data="lineData" :options="lineOptions" />
		</div>
		<div class="card">
			<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
				<h5 class="m-0">Margen bruto</h5>
				<Dropdown class="w-full md:w-auto" v-model="grossMarginTimeSelected" :options="finatialReportTimeOptions" optionLabel="name" @change="onGrossMarginTimeChanged()"></Dropdown>
			</div>
			<span class="block text-500 mb-3">{{ grossMarginPercentLabel }}</span>
			<div v-if="showGrossMarginCostNote" class="flex align-items-start gap-2 mb-3 p-2 border-round" style="background: rgba(59, 130, 246, 0.1);">
				<i class="pi pi-info-circle mt-1" style="color: #3b82f6;"></i>
				<span class="text-500 text-sm">No se detectaron precios de compra para los productos vendidos, por lo que el margen bruto se muestra como el 100% de los ingresos.</span>
			</div>
			<Chart type="line" :data="grossMarginData" :options="grossMarginOptions" />
		</div>
		<div class="card">
			<h5>Ventas Recientes</h5>
			<DataTable class="clickable-rows" :value="this.recentSales" :rows="5" :paginator="true" responsiveLayout="scroll" @row-click="onSaleRowClick($event)">
				<Column style="width:25%">
						<template #header>
							Fecha
						</template>
						<template #body="slotProps">
							{{ slotProps.data.createdAtFormatted }}
						</template>
					</Column>
				<Column style="width:35%">
					<template #header>
						Cliente
					</template>
					<template #body="slotProps">
						{{ slotProps.data.customer.name }}
					</template>
				</Column>
				<Column style="width:15%">
					<template #header>
						Total
					</template>
					<template #body="slotProps">
						${{ slotProps.data.total.toFixed(2) }}
					</template>
				</Column>
				<Column style="width:25%">
					<template #header>
						Actividad
					</template>
					<template #body="slotProps">
						{{ slotProps.data.econActivity.name }}
					</template>
				</Column>
			</DataTable>
		</div>
	</div>
	<div class="col-12 xl:col-6">
		<div class="card">
			<div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
				<h5 class="m-0">Producto/Servicios más vendidos</h5>
				<Dropdown class="w-full md:w-auto" v-model="topProductsDaysSelected" :options="topProductsDaysOptions" optionLabel="name" @change="onTopProductsDaysChanged()"></Dropdown>
			</div>
			<span class="block text-500 mb-3">Unidades vendidas por producto</span>
			<Chart v-if="topProducts.length > 0" type="bar" :data="barData" :options="barOptions" />
			<div v-else class="text-500 text-center py-5">Aún no hay ventas registradas en este periodo.</div>
		</div>
		<div class="card">
			<h5>Cuentas por cobrar vs por pagar</h5>
			<span class="block text-500 mb-3">{{ receivablesNetLabel }}</span>
			<Chart v-if="hasReceivablesData" type="bar" :data="receivablesData" :options="receivablesOptions" />
			<div v-else class="text-500 text-center py-5">No hay cuentas por cobrar ni por pagar pendientes.</div>
		</div>
	</div>
	</div>
</template>

<script>
import EventBus from '@/AppEventBus';
import httpRequest from '../service/httpRequest';	
import Sale from '../models/sale';
import Big from 'big.js';

export default {
	data() {
		return {
			last7daysSalesAmount: new Big(0),
			last30daysSalesAmount: new Big(0),
			last7daysSalesTotal: new Big(0),
			last30daysSalesTotal: new Big(0),
			last7DaysExpensesTotal: new Big(0),
			last30DaysExpensesTotal: new Big(0),
			customerAmount: 0,
			last7DaysCustomers: 0,
			recentSales: [],
			lineData: {
				labels: [],
				datasets: [
					{
						label: 'Ingresos',
						data: [],
						fill: false,
						backgroundColor: '#06c35d',
						borderColor: '#06c35d',
						tension: 0.4
					},
					{
						label: 'Egresos',
						data: [],
						fill: false,
						backgroundColor: '#d45656',
						borderColor: '#d45656',
						tension: 0.4
					}
				]
			},
			finatialReportTimeOptions: [
				{name: 'Últimos 7 días', code: '1'},
				{name: 'Últimos 15 días', code: '2'},
				{name: 'Últimos 30 días', code: '4'},
				{name: 'Últimos 60 días', code: '8'},
				{name: 'Últimos 90 días', code: '12'},
				{name: 'Últimos 6 meses', code: '28'},
			],
			finantialReportTimeSelected: {name: 'Últimos 7 días', code: '1'},
			lineOptions: null,
			grossMarginTimeSelected: {name: 'Últimos 7 días', code: '1'},
			grossMarginTotalMargin: 0,
			grossMarginTotalRevenue: 0,
			grossMarginHasCostData: true,
			grossMarginData: {
				labels: [],
				datasets: [
					{
						label: 'Margen bruto',
						data: [],
						fill: true,
						backgroundColor: 'rgba(20, 184, 166, 0.15)',
						borderColor: '#14b8a6',
						tension: 0.4
					}
				]
			},
			grossMarginOptions: null,
			topProducts: [],
			topProductsDaysOptions: [
				{name: 'Últimos 7 días', code: 7},
				{name: 'Últimos 15 días', code: 15},
				{name: 'Últimos 30 días', code: 30},
				{name: 'Últimos 60 días', code: 60},
				{name: 'Últimos 90 días', code: 90},
			],
			topProductsDaysSelected: {name: 'Últimos 30 días', code: 30},
			receivable: { current: 0, overdue: 0, total: 0, count: 0 },
			payable: { current: 0, overdue: 0, total: 0, count: 0 },
			receivablesNet: 0,
			receivablesData: {
				labels: ['Por cobrar', 'Por pagar'],
				datasets: [
					{
						label: 'Vigente',
						data: [0, 0],
						backgroundColor: '#3b82f6',
						borderColor: '#3b82f6',
						borderRadius: 4,
						borderSkipped: false,
						maxBarThickness: 90,
					},
					{
						label: 'Vencido',
						data: [0, 0],
						backgroundColor: '#d45656',
						borderColor: '#d45656',
						borderRadius: 4,
						borderSkipped: false,
						maxBarThickness: 90,
					}
				]
			},
			receivablesOptions: null,
			barData: {
				labels: [],
				datasets: [
					{
						label: 'Unidades vendidas',
						data: [],
						backgroundColor: '#f18700',
						borderColor: '#f18700',
						borderRadius: 4,
						borderSkipped: false,
					}
				]
			},
			barOptions: null,
		}
	},
	themeChangeListener: null,
	mounted() {
		this.themeChangeListener = (event) => {
            if (event.dark)
                this.applyDarkTheme();
            else
                this.applyLightTheme();
        };
        EventBus.on('change-theme', this.themeChangeListener);

		if (this.isDarkTheme()) {
            this.applyDarkTheme();
        }
        else {
            this.applyLightTheme();
        }
	},
	beforeUnmount() {
        EventBus.off('change-theme', this.themeChangeListener );
    },
	async created() {
		this.getBusinessMetrics();
		this.getFinantialStateData();
		this.getRecentSales();
		this.getTopProducts();
		this.getReceivablesPayables();
		this.getGrossMarginData();
	},
	computed: {
		hasReceivablesData() {
			return this.receivable.total > 0 || this.payable.total > 0;
		},
		grossMarginPercentLabel() {
			if (this.grossMarginTotalRevenue <= 0) return 'Utilidad sobre lo vendido';
			const pct = (this.grossMarginTotalMargin / this.grossMarginTotalRevenue) * 100;
			return 'Margen: ' + pct.toFixed(1) + '% de las ventas';
		},
		showGrossMarginCostNote() {
			return this.grossMarginTotalRevenue > 0 && !this.grossMarginHasCostData;
		},
		receivablesNetLabel() {
			const abs = Math.abs(this.receivablesNet).toFixed(2);
			if (this.receivablesNet > 0) return 'Neto: +$' + abs + ' a favor';
			if (this.receivablesNet < 0) return 'Neto: -$' + abs + ' en contra';
			return 'Neto: $0.00';
		}
	},
	methods: {
		async getBusinessMetrics() {
			let response = await httpRequest.getBusinessMetrics();
			if (response.status == 200) {
				this.last7daysSalesAmount = new Big(response.data.last7daysSalesAmount);
				this.last30daysSalesAmount = new Big(response.data.last30daysSalesAmount);
				this.last7daysSalesTotal = new Big(response.data.last7daysSalesTotal);
				this.last30daysSalesTotal = new Big(response.data.last30daysSalesTotal);
				this.last7DaysExpensesTotal = new Big(response.data.last7DaysExpensesTotal);
				this.last30DaysExpensesTotal = new Big(response.data.last30DaysExpensesTotal);
				this.customerAmount = response.data.customerAmount;
				this.last7DaysCustomers = response.data.last7DaysCustomers;
			}
		},
		async getFinantialStateData() {
			let response = await httpRequest.getFinantialStateData(this.finantialReportTimeSelected.code);
			if (response.status == 200) {
				// Get data
				this.lineData.datasets[0].data = response.data.sales;
				this.lineData.datasets[1].data = response.data.expenses;

				// Setup day labels
				for (var i=0; i<7; i++) {
					let mult = parseInt(this.finantialReportTimeSelected.code);
					var date = new Date();
					date.setDate(date.getDate() - (i * mult));
					this.lineData.labels.unshift(date.toLocaleDateString("es-ES"));
				}	
			}
		},
		async onFinantialReportTimeChanged() {
			// Clear data
			this.lineData.labels = [];
			this.lineData.datasets[0].data = [];
			this.lineData.datasets[1].data = [];

			await this.getFinantialStateData();
		},
		async getRecentSales() {
			let response = await httpRequest.getRecentSales();
			if (response.status == 200) {
				let sales = response.data;
                this.recentSales = sales.map(function(data) { return new Sale(data)});
			}
		},
		async getTopProducts() {
			let response = await httpRequest.getTopProducts(this.topProductsDaysSelected.code);
			if (response.status == 200) {
				this.topProducts = response.data;
				this.barData.labels = response.data.map(p => p.name);
				this.barData.datasets[0].data = response.data.map(p => parseFloat(p.quantity));
			}
		},
		async onTopProductsDaysChanged() {
			await this.getTopProducts();
		},
		async getGrossMarginData() {
			let response = await httpRequest.getGrossMarginData(this.grossMarginTimeSelected.code);
			if (response.status == 200) {
				this.grossMarginData.datasets[0].data = response.data.margin.map(m => parseFloat(m));
				this.grossMarginTotalMargin = parseFloat(response.data.totalMargin);
				this.grossMarginTotalRevenue = parseFloat(response.data.totalRevenue);
				this.grossMarginHasCostData = response.data.hasCostData;

				// Etiquetas de día (mismo criterio que getFinantialStateData)
				let labels = [];
				let mult = parseInt(this.grossMarginTimeSelected.code);
				for (var i = 0; i < 7; i++) {
					var date = new Date();
					date.setDate(date.getDate() - (i * mult));
					labels.unshift(date.toLocaleDateString("es-ES"));
				}
				this.grossMarginData.labels = labels;
			}
		},
		async onGrossMarginTimeChanged() {
			await this.getGrossMarginData();
		},
		async getReceivablesPayables() {
			let response = await httpRequest.getReceivablesPayables();
			if (response.status == 200) {
				let d = response.data;
				this.receivable = {
					current: parseFloat(d.receivable.current),
					overdue: parseFloat(d.receivable.overdue),
					total: parseFloat(d.receivable.total),
					count: d.receivable.count,
				};
				this.payable = {
					current: parseFloat(d.payable.current),
					overdue: parseFloat(d.payable.overdue),
					total: parseFloat(d.payable.total),
					count: d.payable.count,
				};
				this.receivablesNet = parseFloat(d.net);
				this.receivablesData.datasets[0].data = [this.receivable.current, this.payable.current];
				this.receivablesData.datasets[1].data = [this.receivable.overdue, this.payable.overdue];
			}
		},
		onSaleRowClick(event) {
			let sale = event.data;
			if (!sale) return;
			const route = this.$router.resolve({ name: 'saleForm', query: { id: sale.id } });
			window.open(route.href, '_blank');
		},
		isDarkTheme() {
            return this.$appState.darkTheme === true;
        },
		applyLightTheme() {
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#495057'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
					y: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
				}
			};
			this.grossMarginOptions = {
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: (ctx) => ' Margen: $' + ctx.parsed.y.toFixed(2)
						}
					}
				},
				scales: {
					x: {
						ticks: { color: '#495057' },
						grid: { color: '#ebedef' }
					},
					y: {
						ticks: { color: '#495057' },
						grid: { color: '#ebedef' }
					}
				}
			};
			this.barOptions = {
				indexAxis: 'y',
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: (ctx) => ' ' + ctx.parsed.x + ' uds.'
						}
					}
				},
				scales: {
					x: {
						ticks: { color: '#495057' },
						grid: { color: '#ebedef' }
					},
					y: {
						ticks: {
							color: '#495057',
							callback: function(value) {
								const label = this.getLabelForValue(value);
								return label.length > 22 ? label.substring(0, 22) + '…' : label;
							}
						},
						grid: { display: false }
					},
				}
			};
			this.receivablesOptions = {
				plugins: {
					legend: { labels: { color: '#495057' } },
					tooltip: {
						callbacks: {
							label: (ctx) => ' ' + ctx.dataset.label + ': $' + ctx.parsed.y.toFixed(2),
							footer: (items) => {
								const info = items[0].dataIndex === 0 ? this.receivable : this.payable;
								return 'Total: $' + info.total.toFixed(2) + ' · ' + info.count + (info.count === 1 ? ' documento' : ' documentos');
							}
						}
					}
				},
				scales: {
					x: {
						stacked: true,
						ticks: { color: '#495057' },
						grid: { display: false }
					},
					y: {
						stacked: true,
						ticks: { color: '#495057' },
						grid: { color: '#ebedef' }
					}
				}
			};
		},
		applyDarkTheme() {
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#ebedef'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
					y: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
				}
			};
			this.grossMarginOptions = {
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: (ctx) => ' Margen: $' + ctx.parsed.y.toFixed(2)
						}
					}
				},
				scales: {
					x: {
						ticks: { color: '#ebedef' },
						grid: { color: 'rgba(160, 167, 181, .3)' }
					},
					y: {
						ticks: { color: '#ebedef' },
						grid: { color: 'rgba(160, 167, 181, .3)' }
					}
				}
			};
			this.barOptions = {
				indexAxis: 'y',
				plugins: {
					legend: { display: false },
					tooltip: {
						callbacks: {
							label: (ctx) => ' ' + ctx.parsed.x + ' uds.'
						}
					}
				},
				scales: {
					x: {
						ticks: { color: '#ebedef' },
						grid: { color: 'rgba(160, 167, 181, .3)' }
					},
					y: {
						ticks: {
							color: '#ebedef',
							callback: function(value) {
								const label = this.getLabelForValue(value);
								return label.length > 22 ? label.substring(0, 22) + '…' : label;
							}
						},
						grid: { display: false }
					},
				}
			};
			this.receivablesOptions = {
				plugins: {
					legend: { labels: { color: '#ebedef' } },
					tooltip: {
						callbacks: {
							label: (ctx) => ' ' + ctx.dataset.label + ': $' + ctx.parsed.y.toFixed(2),
							footer: (items) => {
								const info = items[0].dataIndex === 0 ? this.receivable : this.payable;
								return 'Total: $' + info.total.toFixed(2) + ' · ' + info.count + (info.count === 1 ? ' documento' : ' documentos');
							}
						}
					}
				},
				scales: {
					x: {
						stacked: true,
						ticks: { color: '#ebedef' },
						grid: { display: false }
					},
					y: {
						stacked: true,
						ticks: { color: '#ebedef' },
						grid: { color: 'rgba(160, 167, 181, .3)' }
					}
				}
			};
		}
	}
}
</script>

<style scoped lang="scss">
	.clickable-rows :deep(.p-datatable-tbody > tr) {
		cursor: pointer;
	}
</style>